import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import {
  BaseComponent,
  ClaimDataService,
  ConfigurationSetting,
  DialogComponent,
  OverlayMode,
  ProgressService,
  SearchResult,
} from 'src/app/shared';
import { ClaimInfo } from 'src/app/shared/models/search-result';
import { UserActionService } from '../../../shared';
import { UserActions } from '../../../shared/models/user';
import { RestrictionTable } from '../../models/Restrictions';
import { RTWResponseStatus } from '../../models/rtw-response';
import { ActivityService } from '../../services/activity.service';
import { ConfigurationService } from '../../services/configuration.service';
import { emulator } from '../../services/emulator.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { LogService } from '../../services/log.service';
import { Session } from '../../services/session.service';
import { UserRoleService } from '../../services/user-role.service';
import { RestrictionsComponent } from './restrictions.component';
import { customvalidations } from 'src/app/shared/models/customvalidations.validator';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-confirm-return-to-work',
    template: `
    <app-section class="tw-w-full">
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb class="tw-w-[90%]"></app-claim-breadcrumb>
      </div>
    
      <app-panel
        [headerLevel]="1"
        title="Confirm return to work"
        class="tw-w-full app-pb4"
        [showTitle]="true"
        [canExpand]="false"
        >
        <app-loading-panel
          [state]="loading || claimLoading ? 'Loading' : 'Loaded'"
          >
          <ng-template #content>
            @if (isRTW === 'confirm') {
              <div
                class="app-pb2 tw-w-full"
                #rtweditdialog
                >
                <form [formGroup]="formGroup">
                  <div id="rtweditpnl">
                    <div class="tw-flex tw-flex-wrap">
                      <div class="tw-w-full md:tw-w-[50%] ">
                        <app-claimant-label
                          value
                          [claimant]="claim"
                          [showNameLabel]="true"
                          [nameClass]="'headingbold'"
                          [disabled]="isOwnClaim"
                          >
                        </app-claimant-label>
                      </div>
                      <div class="app-pb2 tw-w-full md:tw-w-[50%]">
                        <app-claim-label
                          value
                          [claim]="claim"
                          layout="row"
                          [showNameLabel]="true"
                        [hideWatchList]="
                          !(userRole.manager || userRole.controller)
                        "
                        ></app-claim-label>
                      </div>
                      <div class="tw-w-full tw-flex tw-flex-wrap">
                        @if (!isHideButtons) {
                          <div class="tw-w-full">
                            <div class="tw-w-full">
                              <app-container-control
                                ngDefaultControl
                                [formGroup]="formGroup"
                                formControlName="duty"
                                class="app-pb3 headingbold"
                                [label]="confirmLabel"
                                >
                                @if (rtwDateFromNotif) {
                                  <div>
                                    <mat-label
                                      >{{ rtwDateFromNotif | format : 'date' }}
                                    </mat-label>
                                  </div>
                                }
                                <mat-radio-group
                                  aria-label="Confirm return to work"
                                  role="radiogroup"
                                  >
                                  <mat-radio-button
                                    (change)="toggleMethod(1)"
                                    value="'Yes"
                                    >{{'Yes' | translation: translationRequest}}</mat-radio-button
                                    >
                                    <span class="app-pl2"></span>
                                    <mat-radio-button
                                      (change)="toggleMethod(2)"
                                      value="No"
                                      >{{'No' | translation: translationRequest}}</mat-radio-button
                                      >
                                    </mat-radio-group>
                                  </app-container-control>
                                </div>
                                @if (showCRTWDate) {
                                  <div class="tw-w-full app-pt2">
                                    @if (showNoRtwDateMessage) {
                                      <div
                                        class="tw-w-full app-pt2 app-pb2"
                                        >
                                        <span class="line-break"
                                          >{{'If the employee returned to work at an earlier
                                          date, enter it below and click the Submit
                                          button.' | translation: translationRequest}}</span
                                          >
                                          <span class="line-break"
                                            >{{'If the employee will return to work at a future
                                            date, leave the date field empty and click the
                                            Submit button.' | translation: translationRequest }}</span
                                            >
                                          </div>
                                        }
                                        <mat-label class="headingbold">{{
                                          changeLabel | translation: translationRequest
                                        }}</mat-label>
                                        <app-date-control
                            [label]="
                              isManagerRole
                                ? 'Return to Work Date *'
                                : 'Return to Work Date'
                            "
                                          ngDefaultControl
                                          [formGroup]="formGroup"
                                          formControlName="rtwDate"
                                          class="app-pt1 tw-w-full md:tw-w-[40%]"
                                          [maxValue]="!claim.userOwns ? maxDate : null"
                                        ></app-date-control>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (!isHideButtons) {
                                  <div class="tw-w-full app-pt4">
                                    <app-action-row>
                                      <app-button
                                        type="submit"
                                        right2
                                        autofocus
                                        emphasis="High"
                                        mat-raised-button
                                        tabindex="0"
                                        [disabled]="btnDisabled || loading"
                                        (click)="updatereturntoworkDate()"
                                        label="Submit"
                                        >
                                      </app-button>
                                      <app-button
                                        right1
                                        emphasis="Low"
                                        (click)="clearForm()"
                                        label="Clear"
                                        ></app-button
                                        >
                                      </app-action-row>
                                    </div>
                                  }
                                </div>
                                @if (isDisplaySuccess) {
                                  <div>
                                    <br />
                                    <app-toast type="Success">
                                      {{ afterRtwSuccessMessage | translation: translationRequest }}
                                    </app-toast>
                                    @if (uploadDocEnabled) {
                                      <app-action-link
                                        imageUrl="./assets/images/upload.png"
                                        title="Upload documents"
                                        helpText=""
                                        [routerLink]=""
                                        [imageWidth]="60"
                                        [imageHeight]="53"
                                        routerLink="/upload-documents-in-documentstab"
                        [queryParams]="{
                          focus: 'documents',
                          claimId: claim.claimId,
                          source: claim.source,
                          showDialog: true
                        }"
                                      ></app-action-link>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </form>
                        </div>
                      }
                    </ng-template>
                  </app-loading-panel>
                </app-panel>
              </app-section>
    `,
    styles: [
        `
      @media (max-device-width: 480px) {
        ::ng-deep .mat-mdc-text-field-wrapper {
          /* width : 250%;*/
        }
      }

      .line-break {
        display: block;
      }
    `,
    ],
    standalone: false
})
export class ConfirmReturnToWorkComponent
  extends BaseComponent
  implements OnInit
{
  claimId: string = '';
  claimConfig: ConfigurationSetting;
  claimInfo$ = new BehaviorSubject<ClaimInfo>(null);
  dialogData: any;

  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	  });
  @Input()
  showDidNotReturn: boolean = true;

  claim: any;
  isManagerRole: boolean = false;
  restrictionTable: RestrictionTable[];
  isDisplaySuccess: boolean = false;
  afterRtwSuccessMessage: string;
  allowFileUpload: boolean = false;
  btnDisabled: boolean = true;
  showCRTWDate: boolean = false;
  isHideButtons: boolean = false;
  examinerLabel: Aliases;
  isRTW: string = null;
  rtwTypeFromNotif: string = '';
  rtwDateFromNotif: string = '';
  mgrAction: UserActions | null;
  loading: boolean = true;
  claimLoading: boolean = true;
  alertMasterId: string;
  showRtwType: boolean = true;
  confirmLabel: string;
  changeLabel: string;
  maxDate: Date;
  showNoRtwDateMessage: boolean = false;
  rtwDateChanged: boolean = false;
  isOwnClaim: boolean = false;
  uploadDocEnabled: boolean = false;

  @Input()
  LOB: string;

  @Input()
  hideHeader: boolean = false;

  @Input()
  claimsHistory: any;

  isController: boolean = false;

  @Output()
  AfterSuccess: EventEmitter<RTWResponseStatus> =
    new EventEmitter<RTWResponseStatus>();

  get Duty() {
    return this.formGroup.get('duty');
  }

  IsValidDuty: boolean = false;
  formGroup: FormGroup = this.fb.group({
    comments: [],
    noReturn: [],
  });

  @ViewChild('restrictionChild') restrictionChild: RestrictionsComponent;
  @ViewChild('rtweditdialog') rtwdialoag: DialogComponent;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    public session: Session,
    private activityService: ActivityService,
    public claimDataService: ClaimDataService,
    public inpageAliasService: InpageAliasService,
    private configurationService: ConfigurationService,
    public overlayService: ProgressService,
    private enumalatorService: emulator,
    public logService: LogService,
    public userRole: UserRoleService,
    public dialog: MatDialog,
    private userActions: UserActionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.dialogData = data != null ? data : null;
    this.allowFileUpload = this.dialogData.uploadFile;
    this.maxDate = new Date();
  }

  createManagementNotificationForm() {
    this.formGroup.addControl('rtwDate', new FormControl(''));
    this.formGroup.addControl('duty', new FormControl(''));
  }

  async ngOnInit() {
    this.isManagerRole = this.userRole.supervisor;
    this.isController = this.userRole.controller;
    if (this.isManagerRole) {
      this.mgrAction = this.userActions.getAction();
    }
    this.createManagementNotificationForm();
    if (this.configurationService.GetConfig.configFeatures) {
      this.examinerLabel = await this.inpageAliasService.replaceAliases(
        'examinerSingular',
        this.configurationService.GetConfig.configFeatures.aliases
      );
    }
    this.subs.sink = this.route.queryParams.subscribe((p) =>
      this.loadClaimFromUrl()
    );
    this.formGroup.controls['rtwDate'].valueChanges.subscribe(() => {
      this.rtwDateChanged = true;
    });
  }

  private async loadClaimFromUrl() {
    this.isRTW = this.route.snapshot.queryParamMap.get('rtw');
    this.rtwTypeFromNotif =
      this.route.snapshot.queryParamMap.get('rtwType') ?? '';
    this.alertMasterId =
      this.route.snapshot.queryParamMap.get('alertMasterUid');
    const claimId = this.route.snapshot.queryParamMap.get('claimId');
    const source = this.route.snapshot.queryParamMap.get('source');
    if (claimId) {
      const claim = await lastValueFrom(
        this.http.get<SearchResult>(
          `/api/claim/${source}/${claimId}/${'NA'}/summary`
        )
      );
      this.setClaim(claim);
      this.confirmLabel =
        claim.lob === 'DS' || claim.lob === 'WC'
          ? 'Confirm ' +
            this.rtwTypeFromNotif.toUpperCase() +
            ' duty return to work date'
          : 'Confirm return to work date';
      this.changeLabel = claim.userOwns
        ? claim.lob === 'DS' || claim.lob === 'WC'
          ? 'Change my ' +
            this.rtwTypeFromNotif.toUpperCase() +
            //  ' duty return to work date to *'
            ` duty return to work date to${
              this.userRole.manager && !claim.userOwns ? '' : ' *'
            }`
          : //  : 'Change my return to work date to *'
            `Change the return to work date to${
              this.userRole.manager && !claim.userOwns ? '' : ' *'
            }`
        : claim.lob === 'DS' || claim.lob === 'WC'
        ? 'Change the ' +
          this.rtwTypeFromNotif +
          ` duty return to work date to${
            this.userRole.manager && !claim.userOwns ? '' : ' *'
          }`
        : `Change the return to work date to${
            this.userRole.manager && !claim.userOwns ? '' : ' *'
          }`;
      if (!this.claim.userOwns) {
        this.formGroup
          .get('rtwDate')
          .addValidators([
            customvalidations.dateInFuture('Error : Invalid date', null),
          ]);
        this.showNoRtwDateMessage = true;
      }
      this.claimLoading = false;
    }
    const rtwDateFromUrl = this.route.snapshot.queryParamMap.get('rtwDate');
    if (rtwDateFromUrl != null && rtwDateFromUrl != undefined) {
      const valueReplace = rtwDateFromUrl.replaceAll('%2F', '/');
      this.rtwDateFromNotif = valueReplace;
    }

    this.isOwnClaim = this.claim.userOwns;
  }

  private async setClaim(claim: SearchResult) {
    if (claim === null) {
      return;
    }
    this.claimId = claim.claimId;
    this.claimInfo$.next(claim);
    this.claim = claim;
    this.showRtwType = this.claim?.lob !== 'LV';
    this.claimConfig = await this.configurationService.getClaimConfiguration(
      claim
    );
    this.loading = false;
  }

  getErrorMessage() {
    return 'Error : Return to Work Type is required.';
  }

  toggleMethod(val1: number) {
    if (val1 == 1) {
      this.showCRTWDate = false;
      this.btnDisabled = false;
      this.formGroup.get('rtwDate').clearValidators();
      this.formGroup.get('rtwDate').updateValueAndValidity();
    }
    if (val1 == 2) {
      this.showCRTWDate = true;
      this.btnDisabled = false;
    }
  }

  clearForm() {
    this.formGroup.reset();
    this.isDisplaySuccess = false;
    this.afterRtwSuccessMessage = '';
  }

  getAlertType(): string {
    const alertType =
      this.userRole.manager &&
      (this.mgrAction == UserActions.ViewOwnMgrDb ||
        this.mgrAction == UserActions.MgrViewEmpDb)
        ? 'RTW_CONFIRMATION_RM'
        : 'RTW_CONFIRM_NEEDED_A'; // not to overdo the queryparms length

    return alertType;
  }

  geterateTriggerKeyAndSession(
    alertType: string,
    claimNumber: string,
    source: string,
    alertMasterId: string
  ) {
    const triggerKey = `${alertType}_${claimNumber}_${source}`;
    sessionStorage.setItem('triggerKey', triggerKey);
    sessionStorage.setItem('alertMasterId', alertMasterId);
  }

  async updatereturntoworkDate() {
    this.uploadDocEnabled =
      this.claimConfig.features.indexOf('uploaddocuments') > -1;
    this.afterRtwSuccessMessage = '';
    let rtwDateValue;
    let rtwDate;
    if (this.showCRTWDate) {
      rtwDateValue = this.formGroup.get('rtwDate').value;
      if (!rtwDateValue && this.claim.userOwns) {
        const errorMessage = this.isManagerRole
          ? 'Error : New return to work date is required.'
          : 'Error : Change my return to work date to is required.';
        this.formGroup.get('rtwDate').setErrors({ [errorMessage]: true });
        this.formGroup.get('rtwDate').markAsTouched();
        return;
      }

      rtwDate = new Date(rtwDateValue);
      if (isNaN(rtwDate.getTime()) && this.claim.userOwns) {
        this.formGroup
          .get('rtwDate')
          .setErrors({ 'Error : Invalid date': true });
        return;
      }
    }

    const newRtwDate = this.showCRTWDate
      ? !this.claim.userOwns && !rtwDateValue
        ? ''
        : rtwDate.toLocaleDateString()
      : new Date(this.rtwDateFromNotif).toLocaleDateString();

    if (this.formGroup.valid) {
      this.enumalatorService.showAuditorInfo();
      this.overlayService.show(OverlayMode.Spinner, 'Please wait..');

      const request = {
        ClaimUid: this.claim.claimId,
        UniqueId:
          this.claim.lob == 'LV' ? this.claim.claimNumber : this.claim.claimId,
        FileNumber: this.claim.claimNumber,
        LineOfBusiness: this.claim.lob,
        examinerName: this.claim.examinerId,
        NewRtwDate: newRtwDate,
        RtwType: this.rtwTypeFromNotif
          ? this.rtwTypeFromNotif
          : this.formGroup.get('duty').value,
        Message: this.formGroup.get('comments').value ?? '',
        UnknownRtw: newRtwDate === '' ? true : false, // setting this to false as we always have a date for RTW unlike 4.0
        EmpUnum: this.claim.empUnum,
        SourceSystem: this.claim.source,
        AlertMasterUid: this.alertMasterId,
        lob: this.claim.lob,
      };
      this.http.post<any>('/api/returntowork/NewRTWDate', request).subscribe(
        (result) => {
          this.overlayService.hide();
          this.isDisplaySuccess = true;
          const CRTWRBval = this.formGroup.get('duty').value;
          if (result.jurisReqStatus) {
            if (CRTWRBval == 'Yes') {
              this.afterRtwSuccessMessage =
                'Thank you. ' +
                (this.claim.userOwns ? 'Your ' : 'The ') +
                'return to work date has been successfully confirmed.';
            } else {
              if (this.rtwDateChanged) {
                this.afterRtwSuccessMessage =
                  'Thank you. ' +
                  (this.claim.userOwns ? 'Your ' : 'The ') +
                  'return to work date has been successfully updated.';
              } else {
                this.afterRtwSuccessMessage =
                  'Thank you. ' +
                  (this.claim.userOwns ? 'Your ' : this.claim.name + '’s ') +
                  'records have been updated.';
              }
            }

            this.isHideButtons = true;
            const alertType = this.getAlertType();

            this.geterateTriggerKeyAndSession(
              alertType,
              this.claim.claimNumber,
              this.claim.source,
              this.alertMasterId
            );

            this.activityService.DismissNotificationAlert(
              alertType,
              this.claim.claimNumber,
              this.claim.claimId,
              this.claim.source,
              this.claim.userOwns,
              this.claim.lob,
              'Rtw'
            );
          }
        },
        (error) => {
          console.log(error);
          this.overlayService.hide();
        }
      );
    }
  }
}
